<template>
  <div>
    <div id="components-layout-demo-side">
      <v-layout>
        <v-sider v-model="collapsed">
          <div class="logo">
            <img src="../../assets/logo.png" width="100%" />
          </div>
          <v-menu theme="dark" :mode="collapsed?'vertical':'inline'" :data="menuData">
            <template slot-scope="{data}">
              <div v-on:click="(ev) => showView(data.viewKey)">
                <i v-if="data.icon" :class="'anticon anticon-' + data.icon"></i>
                <span :class="{'nav-text':data.icon}">{{data.name}}</span>
              </div>
            </template>
            <template slot-scope="{data}" slot="sub">
              <i v-if="data.icon" :class="'anticon anticon-' + data.icon"></i>
              <span class="nav-text">{{data.name}}</span>
            </template>
          </v-menu>
        </v-sider>
        <v-layout>
          <v-content :style="{ padding: '0 50px' }">
            <p v-if="user" class="logged-in">{{user.email}}</p>
            <div style="padding: 16px; background: #fff;padding-top:0">
              <router-view />
            </div>
            <span class="footer-copyright">© Copyright 2019 - 2020, Maplepro</span>
          </v-content>

        </v-layout>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import fb from '@/firebase'

export default {
  name: 'StudentDashboard',
  data () {
    return {
      collapsed: false,
      userOptions: [
        {content: 'Notification'},
        {content: 'Profile'},
        {content: 'Logout'}
      ],
      menuData: [{
        name: 'Profile',
        viewKey: 'profile',
        icon: 'user',
        selectedKey: 'profile',
        selected: this.$route.path.includes('profile')
      },
      {
        name: 'Applications',
        viewKey: 'applications',
        icon: 'copy',
        selectedKey: 'application',
        selected: this.$route.path.includes('application')
      },
      // {
      //   name: 'Dashboard',
      //   viewKey: 'dashboard',
      //   icon: 'home',
      //   selectedKey: 'dashboard',
      //   selected: this.$route.path.includes('dashboard')
      // },
      {
        name: 'Search Schools',
        viewKey: 'schools',
        icon: 'global',
        selectedKey: 'school',
        selected: this.$route.path.includes('school')
      }, {
        name: 'Search Programs',
        viewKey: 'programs',
        icon: 'book',
        selectedKey: 'program',
        selected: this.$route.path.includes('program')
      }, {
        name: 'Logout',
        viewKey: 'logout',
        icon: 'logout',
        selectedKey: 'logout',
        selected: this.$route.path.includes('logout')
      }]
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  watch: {
    '$route.path': {
      handler (val) {
        debugger
        this.menuData = this.menuData.map((x) => {
          x.selected = val.includes(x.selectedKey)
          return x
        })
      }
    }
  },
  methods: {
    userAction (data) {
      if (data.content === 'Logout') {
        fb.logout()
        this.$router.push('/auth')
      }
    },
    showView (viewKey) {
      if (viewKey === 'dashboard') {
        this.$router.push('/student/dashboard')
      } else if (viewKey === 'schools') {
        this.$router.push('/student/schools')
      } else if (viewKey === 'programs') {
        this.$router.push('/student/programs')
      } else if (viewKey === 'profile') {
        this.$router.push('/student/profile')
      } else if (viewKey === 'applications') {
        this.$router.push('/student/applications')
      }  else if (viewKey === 'logout') {
        fb.logout()
        this.$router.push('/auth')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Student/StudentDashboard.vue